import { createContext, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useFindStandardizationProject from './hooks/useFindStandardizationProject';
import { useLocation } from 'react-router-dom';

const StandardizationScreenContext = createContext(null);
const isStandardizationRouteOpened = (pathname) => /\/standardization\/project\/.+/.test(pathname);

export default function StandardizationScreenProvider({ children }) {
  const history = useHistory();
  const location = useLocation();
  const retrieveStandardizationProject = isStandardizationRouteOpened(location.pathname);
  const { project: standardizationProject, isLoading: isStandardizationProjectLoading } =
    useFindStandardizationProject(retrieveStandardizationProject);
  const [isLeftSideMenuOpen, setLeftSideMenuOpen] = useState(true);
   const [modules, setModules] = useState([]);

  const toggleLeftSideMenu = (newValue) => {
    setLeftSideMenuOpen((currentValue) => (newValue !== undefined ? newValue : !currentValue));
  };

  const setSelectedStandardizationProject = (project) => {
    const projectId = project?.id || null;
    if (standardizationProject?.id === projectId) return;
    let to = projectId ? `/project/${projectId}` : '';
    history.push(`/standardization${to}`);
  };

  return (
    <StandardizationScreenContext.Provider
      value={{
        standardizationProject,
        isStandardizationProjectLoading,
        setSelectedStandardizationProject,
        isLeftSideMenuOpen,
        toggleLeftSideMenu,
          modules,
          setModules,
      }}>
      {children}
    </StandardizationScreenContext.Provider>
  );
}

export const useStandardization = () => useContext(StandardizationScreenContext);
